import { InvalidPatchedFunctionError } from './errors';
/**
 * BaseAspect is an `Aspect` that execute modifiers in sync mode
 */
var BaseAspect = /** @class */ (function () {
    function BaseAspect(contextCreator) {
        this.modifiers = {
            before: [],
            around: [],
            return: [],
            throw: [],
            after: [],
            protect: [],
        };
        this.createContext = contextCreator;
    }
    /**
     * The before stage is triggered when then patched function just accepts it's arguments and not have been called
     */
    BaseAspect.prototype.before = function (modifier) {
        this.modifiers.before.push(modifier);
        return this;
    };
    /**
     * The around modifier prevent the patched function to execute,
     * which can be manually called use the modifier context
     */
    BaseAspect.prototype.around = function (modifier) {
        this.modifiers.around.push(modifier);
        return this;
    };
    /**
     * The throw stage is triggered when the patched function rejects
     */
    BaseAspect.prototype.throw = function (modifier) {
        this.modifiers.throw.push(modifier);
        return this;
    };
    /**
     * The return stage is triggered right before the patched function resolves
     */
    BaseAspect.prototype.return = function (modifier) {
        this.modifiers.return.push(modifier);
        return this;
    };
    /**
     * The after stage is triggered when then patched function resolves or rejects
     */
    BaseAspect.prototype.after = function (modifier) {
        this.modifiers.after.push(modifier);
        return this;
    };
    /**
     * The protect stage is triggered when there is an error thrown by other modifiers
     */
    BaseAspect.prototype.protect = function (modifier) {
        this.modifiers.protect.push(modifier);
        return this;
    };
    /**
     * Patch the target object, and replace the method to the patched function
     * @param target An object to be patched
     * @param key A key to the method to be patched
     */
    BaseAspect.prototype.patch = function (target, key) {
        Object.defineProperty(target, key, {
            enumerable: false,
            value: this.compile(target, key),
            writable: true,
            configurable: true,
        });
    };
    /**
     * Check whether the aspect has registered modifiers, if not it can skip all the patched processes
     */
    BaseAspect.prototype.dirty = function () {
        return Object.values(this.modifiers).some(function (list) { return list.length; });
    };
    /**
     * Return the new function that is already patched
     */
    BaseAspect.prototype.compile = function (target, key) {
        var fn = target[key];
        if (typeof fn !== 'function') {
            throw new InvalidPatchedFunctionError(key);
        }
        var invoke = this.invoke.bind(this);
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return invoke(fn, this, args);
        };
    };
    return BaseAspect;
}());
export default BaseAspect;
//# sourceMappingURL=base-aspect.js.map